<ng-container *ngIf="!chTheme2 && !chTheme11 && !chTheme14 && !chTheme13 && !chTheme15">
    <app-subscribe-ch1 [emaildata]="emaildata"  (onSubmit)="onSubmit()"
        [emailForm]="emailForm" [errorMessage]="errorMessage" [index9]="index9"></app-subscribe-ch1>
</ng-container>
<ng-container *ngIf="chTheme2">
    <app-subscribe-ch2 [emaildata]="emaildata" (onSubmit)="onSubmit()" [emailForm]="emailForm"
        [errorMessage]="errorMessage" [index9]="index9"></app-subscribe-ch2>
</ng-container>

<ng-container *ngIf="chTheme11 || chTheme13 || chTheme14 || chTheme15">
    <app-subscribe-ch11 [emaildata]="emaildata"  (onSubmit)="onSubmit()" [emailForm]="emailForm"
        [errorMessage]="errorMessage" [index9]="index9"></app-subscribe-ch11>
</ng-container>